import { CompatibilityItem } from '../types/compatibility.types'

const CDN = 'https://d1tg5gdu842vo5.cloudfront.net/site-assets/images/compatibility'

export const compatibilityItems: CompatibilityItem[] = [
    {
        id: 'yoto-player',
        name: 'Yoto Player',
        category: 'Kids story player',
        imageUrl: `${CDN}/yoto.jpg`,
        compatible: true,
        adapterRequired: false,
        compatibilityNote: 'The Yoto Player has a built-in 3.5mm headphone jack — just plug in your Kibu headphones and the story begins!',
    },
    {
        id: 'yoto-mini',
        name: 'Yoto Mini',
        category: 'Kids story player',
        imageUrl: `${CDN}/yoto_mini.jpg`,
        compatible: true,
        adapterRequired: false,
        compatibilityNote: 'The Yoto Mini has a built-in 3.5mm headphone jack — your Kibu headphones plug straight in, no fuss.',
    },
    {
        id: 'toniebox',
        name: 'Toniebox 1',
        category: 'Kids story player',
        imageUrl: `${CDN}/tonies_1.jpg`,
        compatible: true,
        adapterRequired: false,
        compatibilityNote: 'The Toniebox 1 has a standard 3.5mm headphone jack on top — Kibu headphones plug right in so little ones can listen to their favourite Tonies privately.',
    },
    {
        id: 'ipod',
        name: 'iPod',
        category: 'Music player',
        imageUrl: `${CDN}/ipod.jpg`,
        compatible: true,
        adapterRequired: false,
        compatibilityNote: 'iPods come with a built-in 3.5mm headphone jack — Kibu headphones connect straight away, ready for all their favourite tunes.',
    },
    {
        id: 'ipad-jack',
        name: 'iPad (Up to 9th Gen)',
        category: 'Tablet',
        imageUrl: `${CDN}/ipad_old.jpg`,
        compatible: true,
        adapterRequired: false,
        compatibilityNote: 'iPads up to the 9th generation have a built-in 3.5mm headphone jack, so Kibu headphones plug straight in — easy!',
    },
    {
        id: 'ipad-nojack',
        name: 'iPad (10th Gen+)',
        category: 'Tablet',
        imageUrl: `${CDN}/ipad.jpg`,
        compatible: true,
        adapterRequired: true,
        adapterNote: 'Requires a Lightning or USB-C to 3.5mm adapter',
        compatibilityNote: 'From the 10th generation onwards, iPads no longer have a headphone jack. You\'ll just need a small Lightning or USB-C to 3.5mm adapter and your Kibu headphones will work perfectly.',
    },
    {
        id: 'iphone-nojack',
        name: 'iPhone',
        category: 'Smartphone',
        imageUrl: `${CDN}/iphone.jpg`,
        compatible: true,
        adapterRequired: true,
        adapterNote: 'Requires a Lightning or USB-C to 3.5mm adapter',
        compatibilityNote: 'iPhones no longer have a headphone jack, but a simple Lightning or USB-C to 3.5mm adapter does the trick — then Kibu headphones are good to go!',
    }
]